<template>
  <div id="refactor-product">
    <header-menu></header-menu>
    <div class="header-banner">
      <div class="banner-content">
        <h1 class="banner-title">{{ bannerData.title || '聚合SDK' }}</h1>
        <p class="banner-description">{{ bannerData.summary || '灰鲸广告联盟聚合SDK，为APP媒体提供聚合广告变现服务，帮助开发者一键接入穿山甲、优量汇、快手、百度等多家广告联盟预算，助力开发者低成本、高效率、高价值实现APP流量广告变现！' }}</p>
        <div class="banner-buttons">
          <div class="left_but" @click="$refs.floatingModal.consultTo('bxzx')">变现咨询</div>
          <div class="right_but" @click="$refs.floatingModal.consultTo('admin')">变现演示</div>
        </div>
      </div>
    </div>
    <div v-for="(item, index) in articleList"
         :key="index"
         :style="index%2==0?'background:#FFFFFF;':'background:#F3F7FF;'
                  +'display: flex; flex-direction: column; align-items: center;'
                  +'text-align: center; width: 100%; max-width: 100%;'" class="container">
      <div class="grid-container">
        <div class="grid-item">
          <!-- 标题 -->
          <h3 class="title">{{ item.title }}</h3>
          <p class="remark">{{ item.remark }}</p>
          <!-- 摘要 -->
          <p class="summary">{{ item.summary }}</p>
          <!-- 封面图 -->
          <img class="cover-image" :src="item.coverImage" alt="封面图">
        </div>
      </div>
    </div>
    <footer-menu></footer-menu>
    <floating-modal ref="floatingModal"></floating-modal>
  </div>
</template>

<script>
import {getArticleList, qryBannerInfo} from '../../api/index.js';
import FooterMenu from '../../components/footer-menu.vue';
import HeaderMenu from "../../components/header-menu.vue";
import FloatingModal from "../../components/floating-modal.vue";

export default {
  name: 'refactor-product',
  components: {
    HeaderMenu,
    FooterMenu,
    FloatingModal,
  },
  data() {
    return {
      articleList: [],
      bannerData: {
        title: '',
        summary: '',
      },
      queryParams: {
        pageNum: 1,
        pageSize: 100,
      },
    }
  },
  created() {
    qryBannerInfo('产品服务Banner').then((res) => {
      if (res.code == 200) {
        this.bannerData = res.data || {}
      }
    });
    document.title = '灰鲸网络-官方资讯';
    this.queryArticleList();
  },
  methods: {
    async queryArticleList() {
      let res = await getArticleList({type: '1'});
      if (res.code == 200) {
        this.articleList = res.rows || []
      }
    },
  },
  // 组件销毁时清除定时器
  beforeDestroy() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  }
}
</script>

<style lang="less">
#refactor-product {
  background-color: #F3F7FF;
  .header-banner {
    margin-top: 80px;
    height: 354px;
    background: url(https://cdn.huimiaokeji.com/bj_cp@2x.png) no-repeat;
    background-size: 100% 354px;
    width: 100%;
    display: flex;
    //align-items: center;
    //justify-content: center;
  }

  .banner-content {
    width: 820px;
    //text-align: center;
    margin-left: 120px;
  }

  .banner-title {
    font-size: 34px;
    margin-top: 60px;
    color: #0B00B5;
    margin-bottom: 16px;
    font-weight: bold;
    //text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  }

  .banner-description {
    font-size: 18px;
    font-weight: 400;
    color: #5D5454;
    margin-bottom: 40px;
    //text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  }

  .banner-buttons {
    display: flex;
    //justify-content: center;
    align-items: center;
    height: 62px;
  }

  .left_but {
    margin-right: 40px;
    width: 178px;
    height: 58px;
    background: #0B00B5;
    font-family: PingFangSC, PingFang SC;
    font-weight: bold;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 60px;
    text-align: center;
    font-style: normal;
    cursor: pointer;
    border: 1px solid #0B00B5;
  }

  .right_but {
    width: 178px;
    height: 58px;
    background: #FFFFFF;
    font-family: PingFangSC, PingFang SC;
    font-weight: bold;
    font-size: 16px;
    color: #0B00B5;
    line-height: 60px;
    text-align: center;
    font-style: normal;
    cursor: pointer;
    border: 1px solid #0B00B5;
  }
  .container {
    margin: 0 auto; /* 居中显示 */
    padding: 100px 0 50px 0; /* 上边距100px，下边距50px */
  }

  .grid-container {
    display: grid;
    grid-template-columns: 1fr; /* 一行只展示一条 */
    gap: 24px; /* 项目间的间距 */
    justify-items: center; /* 内容居中 */
  }

  .grid-item {
    /* 修改为适应单列布局的样式 */
    width: 100%;
    max-width: 800px; /* 可根据需要调整最大宽度 */
    height: auto; /* 自适应高度 */
    cursor: pointer;
    //background: #ffffff;
    border-radius: 12px;
    margin-bottom: 30px;
    //box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    align-items: center; /* 内容居中 */
    text-align: center; /* 文本居中 */
    padding: 20px;

    .cover-image {
      width: 100%;
      max-width: 800px;
      height: auto;
      object-fit: cover;
      border-radius: 12px;
      margin-bottom: 20px;
    }

    .title {
      font-size: 24px;
      margin: 0 0 2px 0;
      padding: 0 20px;
      text-align: center;
      color: #0B00B5;
    }

    .remark {
      width: auto;
      height: auto;
      margin-top: 0px;
      font-size: 18px;
      line-height: 1.2;
      color: #8F9699;
      text-align: center;
      margin-bottom: 20px;
    }

    .summary {
      font-size: 16px;
      color: #666;
      padding: 0 20px;
      margin: 0 0 10px 0;
      line-height: 1.6;
      text-align: center;
      /* 修改为不换行并使用单行省略号 */
      white-space: nowrap; /* 禁止文本换行 */
      overflow: hidden; /* 隐藏超出部分 */
      text-overflow: ellipsis; /* 超出部分显示省略号 */
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/refactor/Product.vue